import { OptionsObject, SnackbarKey, SnackbarMessage, VariantType, useSnackbar } from 'notistack';
import { useCallback, useMemo } from 'react';

export const useSnackbars = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = useCallback(
    (message: SnackbarMessage, options: OptionsObject = {}, variant?: VariantType): SnackbarKey => {
      return enqueueSnackbar(message, {
        ...options,
        variant: variant || options.variant,
      });
    },
    [enqueueSnackbar]
  );

  const showSuccessSnackbar = useCallback(
    (message: SnackbarMessage, options: OptionsObject = {}) => {
      showSnackbar(message, options, 'success');
    },
    [showSnackbar]
  );

  const showErrorSnackbar = useCallback(
    (message: SnackbarMessage, options: OptionsObject = {}) => {
      showSnackbar(message, options, 'error');
    },
    [showSnackbar]
  );

  const showWarningSnackbar = useCallback(
    (message: SnackbarMessage, options: OptionsObject = {}) => {
      showSnackbar(message, options, 'warning');
    },
    [showSnackbar]
  );

  const showInfoSnackbar = useCallback(
    (message: SnackbarMessage, options: OptionsObject = {}) => {
      showSnackbar(message, options, 'info');
    },
    [showSnackbar]
  );

  return useMemo(
    () => ({
      showSnackbar,
      showSuccessSnackbar,
      showInfoSnackbar,
      showErrorSnackbar,
      showWarningSnackbar,
    }),
    [showSnackbar, showSuccessSnackbar, showInfoSnackbar, showErrorSnackbar, showWarningSnackbar]
  );
};
